import { useCopyToClipboard } from "usehooks-ts";

import { useToastStore } from "./toast/toast-store";

export const useCopyValueToClipboard = () => {
  const [, copy] = useCopyToClipboard();

  return async (value: string, label: string) => {
    const pushToast = useToastStore.getState().pushToast;
    const copied = await copy(value);

    if (copied) {
      void pushToast({ type: "success", message: `${label} copied` });

      return;
    }

    void pushToast({ type: "error", message: `${label} could not be copied` });
  };
};
